module.exports = __webpack_public_path__ + "img/html-evolution-3.eb6689e7.jpg";